<template>
  <i-header class="toolbar">
    <row
      :class="[
        'toolbar__row layout-container',
        isFullWidthRoute ? 'full-width' : ''
      ]"
    >
      <i-col :span="type === 'contract' ? 16 : 14" class="toolbar__col menu">
        <slot name="menu"></slot>
      </i-col>
      <i-col :span="type === 'contract' ? 8 : 10" class="toolbar__col tools">
        <slot name="tools"></slot>
      </i-col>
    </row>
  </i-header>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'contract'
    }
  },
  computed: {
    isFullWidthRoute () {
      return (
        this.$route.path.indexOf('dashboard/actual/month') > -1 ||
        this.$route.path.indexOf('dashboard/actual/week') > -1 ||
        this.$route.path.indexOf('time-table') > -1 ||
        this.$route.path.indexOf('register') > -1
      )
    }
  }
}
</script>

<style lang="less">
.toolbar {
  z-index: 100;
  position: sticky;
  top: 0;

  &.ivu-layout-header {
    height: 34px;
    padding: 0;
  }

  .ivu-menu-horizontal {
    height: 34px;
    line-height: 34px;
  }

  .ivu-menu {
    font-size: 12px;
  }
  .ivu-menu-item {
    font-size: 12px;
  }

  &__row {
    line-height: 34px;
  }

  &__col {
    display: flex !important;
    align-items: center;
    height: 34px;

    &.tools {
      justify-content: flex-end;
    }
  }

  .ivu-btn {
    margin-top: -1px;
  }

  .ivu-btn > .ivu-icon {
    line-height: 24px;
  }
}
</style>
